// extracted by mini-css-extract-plugin
module.exports = {"banner_join":"AlumniFAQ_banner_join__SFx_q","card":"AlumniFAQ_card__wcqJG","overlay":"AlumniFAQ_overlay__kdr0e","content":"AlumniFAQ_content__xpoH0"};